import { Environment } from './environment.model';

export const environment: Environment = {
    fayeUrl: 'https://ws.baresto.fr',
    name: 'production',
    tokenCookieName: 'JWT',
    sentryDsn: 'https://680108615be8484a05a16a334975efa7@sentry.infra.ik.spiriit.cloud/35',
    sentryRelease: '2026.10.29',
    analytics: 'GTM-WMNRMLK',
    markerIo: {
        project: '671f9f367a3b33b4b92d8582',
    },
    release: '2026.10.29',
    barestoUser: {
        establishment: 277,
        username: 'demobaresto',
    },
};
